interface SvgSobreNosotrosProps {
    className?: string;
    width?: number | string;
    height?: number | string;
}

const SvgSobreNosotros: React.FC<SvgSobreNosotrosProps> = ({
    className = "",
    width = 34,
    height = 24,

}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="currentColor"
        viewBox="0 0 16 16"
        className={`bi bi-person-workspace pt-0.5 ${className}`}
    >
        <path d="M4 16s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-5.95a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
         /*    fill="white"
            stroke="white"
            strokeWidth="0.5" */
        />
        <path d="M2 1a2 2 0 0 0-2 2v9.5A1.5 1.5 0 0 0 1.5 14h.653a5.4 5.4 0 0 1 1.066-2H1V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v9h-2.219c.554.654.89 1.373 1.066 2h.653a1.5 1.5 0 0 0 1.5-1.5V3a2 2 0 0 0-2-2z"
        /*  fill="white"
         stroke="white"
         strokeWidth="0.5" */
        />

    </svg>



);

export default SvgSobreNosotros;
